import React, { useEffect, useState } from "react";
import { useHistory, useLocation, useRouteMatch } from "react-router-dom";
import FixturePopup from "../fixturePopup";
import {
  disableBodyScroll,
  enableBodyScroll,
  clearAllBodyScrollLocks,
} from "body-scroll-lock";

import config from "../../common/config";
import { Consume } from "../../Context/Consumer";
import { FixturesContext, LoginContext } from "../../Context";
import { getLocalStorage, googleAnalyticsEventTracking } from "../../common";
const SubMenu = (props) => {
  const history = useHistory();
  let location = useLocation();
  let leagueMatch = useRouteMatch(
    config.BASE_DOMAIN_LANG + "league-settings/:leagueID"
  );
  let otherTeamMatch = useRouteMatch(
    config.BASE_DOMAIN_LANG +
      "view-others-team/:GUID/:FullName/:USID/:UsTmID/:GDID?/:PHID?"
  );
  let [close, setClose] = useState(false);
  let targetElement = document.querySelector("body");

  const openHandler = () => {
    const { action, category, label } = config.trackclickEvents.calender;
    googleAnalyticsEventTracking(action, category, label);
    setClose(!close);
    disableBodyScroll(targetElement);
  };
  const closeHandler = () => {
    setClose(!close);
    clearAllBodyScrollLocks();
  };
  let leagueID = leagueMatch === null ? "" : leagueMatch.params.leagueID;
  let otherTeamParams = otherTeamMatch === null ? null : otherTeamMatch.params;
  const backBtnHandler = () => {
    if (location.pathname === "/fantasy/ar/create-team") {
      history.push(config.BASE_DOMAIN_LANG + "home");
    } else if (location.pathname === "/fantasy/en/create-team") {
      history.push(config.BASE_DOMAIN_LANG + "home");
    } else if (
      location.pathname === `/fantasy/ar/league-settings/${leagueID}`
    ) {
      history.push(config.BASE_DOMAIN_LANG + `league-leaderboard/${leagueID}`);
    } else if (
      location.pathname === `/fantasy/en/league-settings/${leagueID}`
    ) {
      history.push(config.BASE_DOMAIN_LANG + `league-leaderboard/${leagueID}`);
    } else if (
      otherTeamParams &&
      location.pathname ===
        `${config.BASE_DOMAIN_LANG}view-others-team/${otherTeamParams.GUID}/${otherTeamParams.FullName}/${otherTeamParams.USID}/${otherTeamParams.UsTmID}/${otherTeamParams.GDID}/${otherTeamParams.PHID}`
    ) {
      let isPublicLb = getLocalStorage("isPublic");
      if (isPublicLb) {
        const CountryId = props.loginData.userProfile.countryID;
        const FavSoccerTeamId = props.loginData.userProfile.favTeamID;
        let TypeId = getLocalStorage("leagueTypeId");
        history.push(
          config.BASE_DOMAIN_LANG +
            `public-leaderboard/${TypeId}/${CountryId}/${FavSoccerTeamId}`
        );
      } else {
        let LeagueId = getLocalStorage("leagueId");
        history.push(
          config.BASE_DOMAIN_LANG + `league-leaderboard/${LeagueId}`
        );
      }
    } else if (location.pathname === `/fantasy/ar/profile`) {
      history.push(config.BASE_DOMAIN_LANG + `home`);
    } else if (location.pathname === `/fantasy/en/profile`) {
      history.push(config.BASE_DOMAIN_LANG + `home`);
    } else if (location.pathname === `/fantasy/en/transfer-summary`) {
      props.FixturesData.setGameMode(config.modes.transfer);
      history.push(`/fantasy/en/manage-team`);
    } else if (location.pathname === `/fantasy/ar/transfer-summary`) {
      props.FixturesData.setGameMode(config.modes.transfer);
      history.push(`/fantasy/ar/manage-team`);
    } else {
      history.goBack();
    }
  };

  if (close) {
    document.addEventListener("backbutton", function (e) {
      e.preventDefault();
      e.stopPropagation();
      setClose(false);
    });
  }

  /* window.opopstate = function() {
    if(close){
      setClose(false);
    }
  } */

  return (
    <React.Fragment>
      <div className="si-main__container--fluid si-bg--black05">
        <div className="si-main__container">
          <div className="si-header">
            <div className="si-header__back">
              <div className="si-btn__back" onClick={backBtnHandler}></div>
            </div>
            <div className="si-header__title">
              <span>{props.pageName}</span>
            </div>
            {location.pathname.split("/")[3] !== "profile" ? (
              <div className="si-header__fixture" onClick={openHandler}>
                <i className="uae-calender"></i>
              </div>
            ) : null}
          </div>
        </div>
      </div>
      <FixturePopup closed={close} closeHandler={closeHandler} />
    </React.Fragment>
  );
};

export default Consume(SubMenu, [LoginContext, FixturesContext]);
